import { render, staticRenderFns } from "./CourseCategory.vue?vue&type=template&id=1cfebebc&"
import script from "./CourseCategory.vue?vue&type=script&lang=js&"
export * from "./CourseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports